export const alphaNumericSort = (objectOne, objectTwo, key) => {
  let valueOne = objectOne[key];
  let valueTwo = objectTwo[key];

  if ((valueOne === null || valueOne === undefined) && (valueTwo === null || valueTwo === undefined)) {
    return 0;
  }

  if (valueOne === null || valueOne === undefined) {
    return 1;
  }

  if (valueTwo === null || valueTwo === undefined) {
    return -1;
  }

  const valueOneOnlyNumbers = containsOnlyNumbers(valueOne);
  const valueTwoOnlyNumbers = containsOnlyNumbers(valueTwo);

  if (valueOneOnlyNumbers && valueTwoOnlyNumbers) {
    valueOne = parseFloat(valueOne);
    valueTwo = parseFloat(valueTwo);

    if (valueOne < valueTwo) return -1;
    if (valueOne > valueTwo) return 1;
    return 0;
  }

  if (typeof valueOne === 'string' && typeof valueTwo === 'string') {
    valueOne = valueOne.trim().toLowerCase();
    valueTwo = valueTwo.trim().toLowerCase();
  }

  if (valueOne < valueTwo) return -1;
  if (valueOne > valueTwo) return 1;
  return 0;
};

const containsOnlyNumbers = (value) => {
  return /^\d+$/.test(value);
};
